import CreatePractitioner from "./Create";

export default CreatePractitioner;
